//dayjs
import dayjs, {Dayjs} from 'dayjs';
//constants
import {
	DAY,
	DD_MM_YYYY_HH_MM_DOT,
	DDD_DD_MMM,
	DDD_DD_MMM_YYYY,
	FOOL_DATE_FORMAT_MERIDIEM,
	FOOL_DATE_FORMAT_UTC,
	HH_MM,
	MERIDIEM_HOUR_FORMAT,
	YEAR,
} from '@/utils/constants';

// export const defaultMaxTimeValue = dayjs().set(HOUR, 12).set(MINUTE, 0);
export const defaultMaxTimeValue = dayjs().hour(23).minute(59).second(59);

export const meridiemOptions = [
	{id: '0', name: 'am'},
	{id: '1', name: 'pm'},
];

export const getMeridiemChangingTime = (meridiem: string, time: string | number) => {
	const hours = (time as string).substring(0, 5);
	const newTime = `${hours} ${meridiem}`;
	return newTime;
};

export const getChangingTime = (time: Dayjs | null, meridiem: string | number) => {
	const formattedTime = dayjs(time).format(HH_MM);
	const newTime = dayjs(`${formattedTime} ${meridiem}`, MERIDIEM_HOUR_FORMAT).format(MERIDIEM_HOUR_FORMAT);
	return newTime;
};

export const formatToUtsDateTime = (date: string, time: string) => {
	const dateTime = dayjs(`${date} ${time}`).format(FOOL_DATE_FORMAT_MERIDIEM);
	const formattedDateTime = dayjs(dateTime).format(FOOL_DATE_FORMAT_UTC);
	return formattedDateTime;
};

export const calculateNotificationTime = (date: string) => {
	const dateSendNotifications = dayjs(date);
	const time = dateSendNotifications.format(HH_MM);

	const dateSendNotificationsInMs = dayjs(date).valueOf();
	const dateNow = dayjs().valueOf();

	const timeDifference = dateNow - dateSendNotificationsInMs;

	const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

	const hoursPass = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

	const minutesPass = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

	if (days > 0) return time;
	if (hoursPass > 0) return `${hoursPass} hr`;
	if (minutesPass > 0) return `${minutesPass} min`;
	return '< 1 min';
};

export const defineSendNotificationDay = (date: string) => {
	const dateSend = dayjs(date);
	const now = dayjs();

	if (dateSend.isSame(now, DAY)) {
		return 'Today';
	}
	if (dateSend.isSame(now.subtract(1, DAY), DAY)) {
		return 'Yesterday';
	}
	if (dateSend.isSame(now, YEAR)) {
		return `${dateSend.format(DDD_DD_MMM)}`;
	}

	return dateSend.format(DDD_DD_MMM_YYYY);
};

export const formatDateTimeFromUtc = (date: string) => dayjs(date).format(DD_MM_YYYY_HH_MM_DOT);
